import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";

const ShiftSelect = ({ value, onChange }) => {
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchShifts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/shifts/list`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const transformedShifts = response.data.map((shift) => ({
          value: shift.shift_id,
          label: shift.shift_name,
        }));
        setShifts(transformedShifts);
      } catch (error) {
        console.error("Error fetching shifts:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchShifts();
  }, []);

  const handleChange = (selectedOption) => {
    onChange(selectedOption ? { value: selectedOption.value, label: selectedOption.label } : null);
  };

  return (
    <Select
      options={shifts}
      placeholder="Select Shift"
      isLoading={loading}
      value={value ? shifts.find((option) => option.value === value.value) || null : null}
      onChange={handleChange}
      isClearable
    />
  );
};

export default ShiftSelect;
